import React, { useEffect, useState } from "react";
import _ from "lodash";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { connect, useSelector } from "react-redux";
import { Button } from "reactstrap";

import winnerImg from "../../../assets/images/sbs/caption-img.png";
import logo from "../../../assets/images/sbs/Logo-Say-What.png";

const CcOver = ({
  onHomeBtn,
  users,
  cc_onPlayAgain,
  captionsArray,
  ...props
}) => {
  const captionImage = useSelector(
    (state) => state.gameReducer?.roomObj?.game_state?.photo
  );
  const roomData = _.get(props, "gameReducer.roomObj");
  const playerArray = _.get(roomData, "game_state.player");

  var voteArray = _.map(playerArray, "vote");
  var result = Number(_.head(_(voteArray).countBy().entries().maxBy(_.last)));
  const most_voted_caption = captionsArray[result];
  const count = playerArray.filter((item) => item.vote === result).length;
  // const [winnerUser, setWinnerUser] = useState([]);

  let votes = _.map(playerArray, "vote");
  let vote_array = [...Array(users.length).keys()].fill(0);
  votes.forEach((vote) => {
    vote_array[vote]++;
  });
  const m = Math.max(...vote_array);
  const max_indexes = vote_array.reduce(
    (p, c, i, a) => (c == m ? p.concat(i) : p),
    []
  );
  let most_voted_captions = captionsArray.filter(
    (_, index) => max_indexes.find((item) => item === index) !== undefined
  );
  const winner_users = users.filter(
    (user) =>
      most_voted_captions.find((item) => item.player_id === user.player_id) !==
      undefined
  );
  let winning_captions = most_voted_captions.map((item, i) => {
    return {
      ...item,
      display_name: winner_users.find(
        (user) => user.player_id === item.player_id
      ).display_name,
    };
  });
  const resultPercentage = Math.round((m / captionsArray.length) * 100);

  // useEffect(() => {
  //   if (
  //     users &&
  //     users.length > 0 &&
  //     most_voted_caption &&
  //     most_voted_caption.length > 0
  //   ) {
  //     const temp = users?.filter((item) => {
  //       for (let elem of most_voted_caption) {
  //         if (elem.player_id === item.player_id) {
  //           return true;
  //         }
  //       }
  //       return false;
  //     });
  //     setWinnerUser(temp);
  //   } else {
  //     setWinnerUser([]);
  //   }
  // }, [most_voted_caption]);

  return (
    <>
      <div className="your-winner">
        <div className="winner-content text-center">
          <img src={logo} alt="logo" />
          {m !== 0 ? (
            <p className="txt">YOUR WINNER!</p>
          ) : (
            <p className="txt">NO WINNERS</p>
          )}
          <img src={captionImage} className="winner-img" alt="img" />
          {m !== 0 ? (
            <div className="winner-list winner-list2">
              {winning_captions &&
                winning_captions.length > 0 &&
                winning_captions?.map((user) => (
                  <>
                    <div>
                      <h3 className="quest">"{user?.caption}"</h3>
                      <h4 className="by"> by: {user?.display_name}</h4>
                    </div>
                  </>
                ))}
            </div>
          ) : m === 0 && captionsArray.length === 0 ? (
            <div className="thanx-part text-center">
              <p className="thanx"> Nobody submitted a caption.</p>
            </div>
          ) : (
            <div className="thanx-part text-center">
              <p className="thanx"> Nobody voted for a winning caption.</p>
            </div>
          )}
        </div>
        {m !== 0 && (
          <p className="percent text-center">
            {resultPercentage}% ({m} / {captionsArray.length})
          </p>
        )}
        <div className="thanx-part text-center">
          {m !== 0 ? (
            <p className="thanx">Thanks for playing!</p>
          ) : (
            <p className="thanx">Try again!</p>
          )}
          {/* <Button onClick={() => onHomeBtn()} className="home-btn">
            Home
          </Button> */}
          <Button onClick={() => cc_onPlayAgain()} className="play-again">
            Play Again?
          </Button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

export default compose(withRouter, connect(mapStateToProps))(CcOver);
